module.exports = __webpack_public_path__ + "static/img/hall_natural.8c3f53f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/hall_natural.png
// module id = EzW5
// module chunks = 12